import {
  FormControl,
  FormLabel,
  Typography,
  CheckboxProps as TypeCheckboxProps,
  FormControlProps,
} from '@mui/joy'
import { ParseKeys } from 'i18next'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Checkbox as StyledCheckbox } from '../ui/styled'

type LabelOnly = {
  label: string
  labelI18n?: never
}

type LabelI18nOnly = {
  label?: never
  labelI18n: ParseKeys
}

type RequiredLabel = LabelOnly | LabelI18nOnly

type CheckboxProps = TypeCheckboxProps & {
  name: string
  formControlProps?: FormControlProps
} & RequiredLabel

export function Checkbox({
  name,
  label,
  labelI18n,
  formControlProps,
  ...props
}: CheckboxProps) {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      defaultValue={false}
      render={({ field: { onChange, value } }) => (
        <FormControl
          orientation='horizontal'
          {...formControlProps}
          sx={{ alignItems: 'center', ...formControlProps?.sx }}
        >
          <StyledCheckbox
            {...props}
            name={name}
            checked={!!value}
            onChange={() => !props.readOnly && onChange(!value)}
            sx={{
              ...(props.readOnly
                ? {
                    input: {
                      cursor: 'unset !important',
                    },
                  }
                : {}),
            }}
          />
          <FormLabel sx={{ marginLeft: '8px' }}>
            <Typography fontSize='14px'>{label ?? t(labelI18n)}</Typography>
          </FormLabel>
        </FormControl>
      )}
    />
  )
}
